var util = require("./util");
var PDFBlock = require("./block");
function PDFInlineBlock(options, children) {
    PDFBlock.call(this, options, children);
    this.verticalAlign = util.getOption(options, "verticalAlign", "baseline");
    // if (typeof (this.width) !== 'number') throw new Error("Inline blocks must have defined width.");
}
util.inherits(PDFInlineBlock, PDFBlock);
function hashCursor(cursor) {
    return cursor.width;
}
PDFInlineBlock.prototype.boxWidth = function (cursor) {
    if (this.width === "auto") {
        return cursor.width;
    }
    else {
        return this.width;
    }
};
PDFInlineBlock.prototype.calc = function (cursor) {
    var cacheKey = hashCursor(cursor);
    if (this.cache.has(cacheKey))
        return this.cache.get(cacheKey);
    var blockMeasure = PDFBlock.prototype.calc.call(this, cursor);
    if (this.width === "auto" && blockMeasure._collapsedWidth < blockMeasure.width) {
        var newCursor = util.extend({}, cursor, {
            width: blockMeasure._collapsedWidth
        });
        var ret = PDFBlock.prototype.calc.call(this, newCursor);
        this.cache.set(cacheKey, ret);
        return ret;
    }
    this.cache.set(cacheKey, blockMeasure);
    return blockMeasure;
};
PDFInlineBlock.prototype.draw = function (cursor) {
    if (this.width === "auto") {
        var measure = this.calc(cursor);
        cursor = util.extend({}, cursor, {
            width: measure._collapsedWidth
        });
    }
    return PDFBlock.prototype.draw.call(this, cursor);
};
PDFInlineBlock.prototype.isInlineBlock = function () {
    return true;
};
module.exports = PDFInlineBlock;
//# sourceMappingURL=module.js.map